import React, { useState } from "react";
import { Col, FormGroup, Input, Row, Container } from "reactstrap";
import env from "env";
import FilePicker from "components/common/FilePicker";
import { Controller } from "react-hook-form";
import TextPopup from "components/common/TextModal";
import CountryTable from "components/common/CountryTable";
import useAlert from "hooks/useAlert";
import PopupTable from "components/common/PopupTableUsed";
import content from "../content";
import commenContent from "components/common/content";

// router
import { useRouteMatch } from "react-router-dom";

// get culture from utils
import getCulture from "utils/getCulture";
const EditAirshipment = ({
  editImage,
  setEditImage,
  control,
  errors,
  setValue,
}) => {
  const [countryTable, setCountryTable] = useState(false);
  const [customerModal, setCustomerModal] = useState(false);
  const rout = useRouteMatch();
  const culture = getCulture(rout.url);

  const { alert, sweetAlert } = useAlert();

  const handleCancel = () => {
    setCountryTable(false);
    setCustomerModal(false);
  };

  return (
    <div>
      {alert}
      <Row>
        <Col md="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="client">
              {commenContent.client[culture]}
            </label>
            <Controller
              control={control}
              name="client"
              rules={{ required: "Client field is required" }}
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="client"
                  placeholder={commenContent.client[culture]}
                  type="text"
                  className={errors.client && "error"}
                  value={value || ""}
                  onChange={({ target: { value } }) => onChange(value)}
                  onClick={() => setCustomerModal(true)}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="weight">
              {commenContent.weight[culture]}
            </label>
            <Controller
              control={control}
              name="weight"
              rules={{ required: "Client field is required" }}
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="weight"
                  type="number"
                  value={value || 0}
                  className={errors.weight && "error"}
                  onWheel={(e) => e.target.blur()}
                  onChange={({ target: { value } }) => onChange(+value)}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="numberOfPkgs">
              {content.numberOfPackages[culture]}
            </label>
            <Controller
              control={control}
              name="numberOfPkgs"
              rules={{ required: "Client field is required" }}
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="numberOfPkgs"
                  type="number"
                  value={value || 0}
                  className={errors.numberOfPkgs && "error"}
                  onWheel={(e) => e.target.blur()}
                  onChange={({ target: { value } }) => onChange(+value)}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="country">
              {commenContent.country[culture]}
            </label>
            <Controller
              control={control}
              name="country"
              rules={{ required: "country field is required" }}
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="country"
                  placeholder={commenContent.country[culture]}
                  type="text"
                  value={value || ""}
                  className={errors.country && "error"}
                  onChange={({ target: { value } }) => onChange(value)}
                  onClick={() => setCountryTable(true)}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="commidityType">
              {commenContent.commodityType[culture]}
            </label>
            <Controller
              control={control}
              name="commodityType"
              rules={{ required: "Commodity type field is required", min: 1 }}
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="commidityType"
                  placeholder={content.followUpStatus[culture]}
                  type="select"
                  value={value || "disabled"}
                  className={errors.commodityType && "error"}
                  onChange={({ target: { value } }) => onChange(+value)}
                >
                  <option disabled value="disabled">
                    {`-- ${commenContent.selectOption[culture]} --`}
                  </option>
                  {env.commidityType.map((status, i) => (
                    <option key={i} value={i + 1}>
                      {status}
                    </option>
                  ))}
                </Input>
              )}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="commodity">
              {commenContent.commodity[culture]}
            </label>
            <Controller
              control={control}
              name="commodity"
              render={({ field: { ref, onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="commodity"
                  type="textarea"
                  style={{ resize: "none" }}
                  value={value || ""}
                  onChange={({ target: { value } }) => onChange(value)}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="12">
          <label className="form-control-label" htmlFor="img">
            {commenContent.uploadImg[culture]}
          </label>
          <FilePicker
            images={editImage}
            setImages={(files) => setEditImage(files)}
          />
        </Col>
      </Row>
      <TextPopup
        modal={countryTable}
        text={commenContent.next[culture]}
        handleCancel={handleCancel}
        fn={() => {}}
        color="primary"
        noBtn
      >
        <Container>
          <CountryTable
            setCountryTable={setCountryTable}
            setValue={setValue}
            sweetAlert={sweetAlert}
          />
        </Container>
      </TextPopup>
      <TextPopup
        modal={customerModal}
        text={commenContent.next[culture]}
        handleCancel={handleCancel}
        fn={() => {}}
        color="primary"
        noBtn
      >
        <Container>
          <PopupTable
            setCustomer={(obj) => setValue("customerId", obj.id)}
            setTableModal={setCustomerModal}
            setValue={setValue}
            sweetAlert={sweetAlert}
          />
        </Container>
      </TextPopup>
    </div>
  );
};

export default EditAirshipment;
